<template>
    <div
        class="wishlist-list-card"
        @click="onListCardClick"
        role="button"
        tabindex="0"
        @keypress.enter="onListCardClick"
        @keypress.space="onListCardClick"
        :aria-label="`View details for ${listName}`"
    >
        <div class="wishlist-list-card__header">
            <h4 class="wishlist-list-card__header-title">{{ listName }}</h4>
            <div class="wishlist-list-card__header-next-cta" aria-label="Next">
                <svg aria-hidden="true">
                    <use xlink:href="#icon-next"></use>
                </svg>
            </div>
        </div>

        <div class="wishlist-list-card__image-container">
            <div
                class="wishlist-list-card__image-wrapper"
                v-for="(product, index) in displayedProducts"
                :key="product.epi"
            >
                <ImageField
                    v-if="index < 3"
                    class="wishlist-list-card__image"
                    :obj="{ url: product.iu, alt: product.dt, width: '575.67', height: '719.58' }" :isLoadingLazy="true"
                    role="img"
                />
                <div v-else-if="index === 3" class="wishlist-list-card__remaining-count" role="note">
                    {{ remainingCount }} more
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, computed, toRefs } from 'vue';
import ImageField from '../../../../global/image.vue';

const props = defineProps({
    listDetails: {
        type: Object,
        default: { }
    },

    handleListCardClick: {
        type: Function,
        default: () => { }
    },
});

const { lname: listName, listcontents: listContents } = toRefs(props.listDetails);

const displayedProducts = computed(() => {
    return listContents.value.slice(0, 4); // Get up to 4 products
});

const remainingCount = computed(() => {
    return Math.max(0, listContents.value.length - 3); // Calculate remaining count if more than 3
});

const onListCardClick = () => {
    props.handleListCardClick(props.listDetails);
};
</script>
